import React, { useEffect, useMemo } from 'react';
import { useFormatter } from 'js/hooks/useFormatter';
import { useComponentProps } from 'js/hooks/component';
import { useSelector, useDispatch } from 'react-redux';
import { SPORTSBOOK_REDUCER } from 'js/store/constants';
import { compose, path, prop } from 'js/utils/ramda.util';
import { withComponent } from 'js/components/hocs/withComponent';
import { componentService } from 'js/services/component.service';
import { useCustomSelector, useUserSelector } from 'js/store/hooks';

import * as helpers from './helpers';
import * as actions from './store/actions';

export const SportsbookBalanceBare = () => {
    const dispatch = useDispatch();
    const formatter = useFormatter();
    const { type } = useComponentProps();
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const balances = useCustomSelector(SPORTSBOOK_REDUCER, prop('balances'));
    const isAppInitialized = useSelector(path([SPORTSBOOK_REDUCER, 'isAppInitialized']));
    const balance = useMemo(() => helpers.getBalanceByName(type, balances, formatter), [balances, formatter, type]);

    useEffect(() => {
        dispatch(actions.startIntegration());
    }, [dispatch]);

    if (!isLoggedIn || !isAppInitialized) {
        return null;
    }

    return <span>{balance}</span>;
};

export const SportsbookBalance = compose(
    withComponent()
)(SportsbookBalanceBare);

componentService.registerWebContentComponents({ SportsbookBalance });
